import Text from '@ingka/text';
import classNames from 'classnames';
import { memo } from 'react';
import styles from './PageIndicator.module.scss';

export type PageIndicatorProps = {
  text: string;
  pages: number;
  currentPage: number;
};

/**
 * Components to indicate which step you are on for some number of pages
 */
export const PageIndicator: React.FC<PageIndicatorProps> = memo(({ text, pages, currentPage }) => {
  const indicatorComponents = Array.from({ length: pages * 2 - 1 }, (_, index) => {
    if (index % 2 === 0) {
      // circle
      const circleNo = index / 2 + 1;
      return (
        <span
          key={index}
          className={classNames(styles['circle'], {
            [styles['circle--highlight']]: circleNo <= currentPage,
          })}
        />
      );
    }
    // line segment
    const lineNo = (index + 1) / 2;
    return (
      <span
        key={index}
        className={classNames(styles['line'], {
          [styles['line--highlight']]: lineNo < currentPage,
        })}
      />
    );
  });

  return (
    <div
      className={styles['component-container']}
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={pages}
      aria-valuenow={currentPage}
    >
      <Text className={styles['text']}>{text}</Text>
      <div className={styles['indicator-container']}>{indicatorComponents}</div>
    </div>
  );
});
